module.exports = __webpack_public_path__ + "img/chevron-left-solid.8b596a11.svg";